export const excludeFilterProperties = (filter:any,isMobile:boolean=false)=>{
    const currentFilter = {...filter}
  
    delete currentFilter["PageIndex"]
    delete currentFilter["PageSize"]
    delete currentFilter["SortProperty"]
    delete currentFilter["SortType"]
    delete currentFilter["IncludeProperties"]
    delete currentFilter["CategoryId"]
    delete currentFilter["CityId"]
    delete currentFilter["cityId"]
    if(!isMobile)
    {

      delete currentFilter["StartDate"]
      delete currentFilter["EndDate"]
    }
    delete currentFilter["categoryContainer"]

    delete currentFilter["DistrictIds"]
    delete currentFilter["districtNames"]
    delete currentFilter["districtIds"]
    delete currentFilter["NeighbourhoodIds"]
    delete currentFilter["neighbourhoodNames"]
    delete currentFilter["neighbourhoodIds"]
    delete currentFilter["IsSearchFilter"]
    delete currentFilter["OptionIdList"]
    delete currentFilter["EidsApproved"]
    delete currentFilter["Type"]
    delete currentFilter["SelectedOptionList"]
    delete currentFilter["selectedOptionListObj"]
    delete currentFilter["CurrencyId"]
    delete currentFilter["categoryUrl"]
    delete currentFilter["categoryDescription"]
    delete currentFilter["categoryDisplayUrl"]
    delete currentFilter["mainCategoryOptionId"]
    delete currentFilter["mainCategoryCount"]
    delete  currentFilter["categoryType"]
    return currentFilter

  }

  export const excludeFilterPropertiesOnRequest = (filter:any)=>{
    const currentFilter = {...filter}
    delete currentFilter["cityName"]
    delete currentFilter["cityNams"]
    delete currentFilter["districtName"]
    delete currentFilter["districtNames"]
    delete currentFilter["neighbourhoodName"]
    delete currentFilter["neighbourhoodNames"]
    delete currentFilter["stateProvinceName"]
    delete currentFilter["currencyName"]
    delete currentFilter["eidsTypeName"]
    delete currentFilter["selectedOptionListObj"]
    delete currentFilter["categoryUrl"]
    delete currentFilter["categoryDescription"]
    delete currentFilter["CurrencyName"]
    delete currentFilter["stateProvinceName"]
    delete currentFilter["categoryDisplayUrl"]
    delete currentFilter["mainCategoryOptionId"]
    delete currentFilter["categoryContainer"]
    delete currentFilter["mainCategoryCount"]
    delete  currentFilter["categoryType"]
    
   

    if(currentFilter?.OptionIdLists)
    {
      currentFilter["OptionIdList"] = JSON.stringify(currentFilter?.OptionIdList)
    }
   
    return currentFilter
  }